<template>
  <div class="elevator">
    <div class="elevator__top">
      <div class="elevator__dial" @click="clickDial"></div>
      <div class="elevator__arrow"></div>
    </div>
    <div class="elevator__door-left"></div>
    <div class="elevator__door-right"></div>
  </div>
</template>

<script>
export default {
  name: 'Elevator',
  props: ['modal'],
  data() {
    return {
      floor: 0,
      touchY: 0,
      scrolled: new Date().getTime(),
      arrowAngle: 7.5,
      arrowScale: 1,
    };
  },
  methods: {
    scaleHeader() {
      const topHeight = Math.min((125 / 598) * window.innerWidth, window.innerHeight / 5, 125);
      const doorHeight = `${window.innerHeight - topHeight}px`;
      this.$el.querySelector('.elevator__top').style.height = `${topHeight}px`;
      this.$el.querySelector('.elevator__door-left').style.height = doorHeight;
      this.$el.querySelector('.elevator__door-right').style.height = doorHeight;

      const floorName = window.location.hash;
      if (floorName === '#/about') {
        this.floor = 1;
        this.arrowAngle = 45.5;
      } else if (floorName === '#/portfolio') {
        this.floor = 2;
        this.arrowAngle = 133.5;
      } else if (floorName === '#/contact') {
        this.floor = 3;
        this.arrowAngle = 170.5;
      } else {
        this.floor = 0;
        this.arrowAngle = 7.5;
      }
      this.arrowScale = topHeight / 125;
      this.$el.querySelector('.elevator__arrow').style.transform = `rotate(-${this.arrowAngle}deg) scale(${this.arrowScale})`;
    },
    clickDial(e) {
      const dy = e.clientY - (this.$el.querySelector('.elevator__top').clientHeight * 0.976);
      const dx = e.clientX - (window.innerWidth / 2);
      const angle = Math.abs(Math.atan2(dy, dx) * (180 / Math.PI));
      if (angle <= 22) this.showRoom(0);
      else if (angle <= 90) this.showRoom(1);
      else if (angle <= 158) this.showRoom(2);
      else this.showRoom(3);
    },
    showRoom(floor) {
      this.floor = floor;
      this.$el.querySelector('.elevator__door-left').style.left = '';
      this.$el.querySelector('.elevator__door-right').style.left = '';

      setTimeout(() => {
        const floors = ['/', '/about', '/portfolio', '/contact'];
        this.$router.push(floors[floor]);
        // Reset zoom somehow?
      }, 1000);

      setTimeout(() => {
        this.$el.querySelector('.elevator__door-left').style.left = '-50%';
        this.$el.querySelector('.elevator__door-right').style.left = '100%';
      }, 1500);
    },
    mouseWheel(e) {
      const lastScroll = this.scrolled;
      this.scrolled = new Date().getTime();
      if (this.scrolled - lastScroll < 250 || this.modal) return; // Debounce.

      if (e.deltaY < 0 && this.floor !== 0) this.showRoom(this.floor - 1);
      else if (e.deltaY > 0 && this.floor !== 3) this.showRoom(this.floor + 1);
    },
    touchStart(e) {
      this.touchY = parseInt(e.changedTouches[0].clientY, 10);
    },
    touchEnd(e) {
      const deltaY = this.touchY - parseInt(e.changedTouches[0].clientY, 10);
      // istanbul ignore else
      if (Math.abs(deltaY) >= 100) { this.mouseWheel({ deltaY }); }
    },
  },
  mounted() {
    setTimeout(() => {
      this.$el.querySelector('.elevator__door-left').style.left = '-50%';
      this.$el.querySelector('.elevator__door-right').style.left = '100%';
    }, 500);

    window.addEventListener('wheel', this.mouseWheel);
    window.addEventListener('touchstart', this.touchStart);
    window.addEventListener('touchend', this.touchEnd);
    window.addEventListener('resize', this.scaleHeader);
    this.scaleHeader();
  },
  beforeDestroy() {
    window.removeEventListener('wheel', this.mouseWheel);
    window.removeEventListener('touchstart', this.touchStart);
    window.removeEventListener('touchend', this.touchEnd);
    window.removeEventListener('resize', this.scaleHeader);
  },
};
</script>

<style lang="scss" scoped>
@import '../tools.mixins';

.elevator {
  &__top {
    @include abs(0, 0, 125px, 100%);
    background: url(../assets/nav/header-tile.png) repeat;
    z-index: 6;
  }
    &__dial {
      @include abs(0, calc(50% - 310px), 100%, 620px);
      border-radius: 50% 50% 0 0 / 100% 100% 0 0;
      background: url(../assets/nav/dial.png) bottom center no-repeat;
      background-size: contain;
      overflow: hidden;
      cursor: pointer;
    }
    &__arrow {
      @include abs(auto, calc(50% - 5px), 38px, 100px);
      bottom: -15px;
      transform-origin: 6px 19px;
      transition: transform 1s;
      background: url(../assets/nav/arrow.png) center no-repeat;
      background-size: contain;
      pointer-events: none;
    }

  @mixin door {
    @include abs(auto, 0, calc(100vh - 125px), 50%);
    bottom: 0;
    transition: left 1s;
    background: url(../assets/nav/door.jpg) center no-repeat;
    background-size: 100% 100%;
    z-index: 5;
  }
  &__door-right {
    @include door;
    left: 50%;
  }
  &__door-left {
    @include door;
    transform: scaleX(-1);
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Elevator.vue